import { Check } from "lucide-react";

const STEPS = ["Acquisizione", "Testo OCR", "Mappa mentale", "Esporta & salva"];

const stepClass = (active, done) => (active ? "text-[#5EEAD4]" : done ? "text-[#059669]" : "text-zinc-400");

export const Stepper = ({ step }) => (
  <ol className="grid grid-cols-4 border border-zinc-200 bg-white mb-8" data-testid="wizard-stepper">
    {STEPS.map((s, i) => {
      const n = i + 1;
      const active = step === n;
      const done = step > n;
      return (
        <li key={s} data-testid={`stepper-step-${n}`} className={`px-3 sm:px-5 py-4 border-r last:border-r-0 border-zinc-200 ${active ? "bg-[#0F3D3E] text-white" : ""}`}>
          <span className={`font-mono text-[11px] ${stepClass(active, done)}`}>{done ? <Check className="w-3.5 h-3.5 inline" /> : `0${n}`}</span>
          <p className={`text-xs sm:text-sm font-semibold mt-1 ${active ? "" : done ? "text-zinc-950" : "text-zinc-400"}`}>{s}</p>
        </li>
      );
    })}
  </ol>
);
